<template>
    <svg width="107" height="105" viewBox="0 0 107 105" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_851_8931)">
            <g clip-path="url(#clip1_851_8931)">
                <g clip-path="url(#clip2_851_8931)">
                    <path
                        d="M60.8008 14.7227V31.6227C60.8008 34.4827 63.1408 36.8227 66.0008 36.8227H82.9008L60.8008 14.7227Z"
                        fill="#84BD00" />
                    <path
                        d="M77.7008 91.4219H28.3008C24.7474 91.4219 21.8008 88.4752 21.8008 84.9219V19.9219C21.8008 16.3685 24.7474 13.4219 28.3008 13.4219H61.7541L62.1008 13.7685C66.3475 18.0152 69.7275 21.3952 73.0208 24.6885C76.3141 27.9819 79.6075 31.2752 83.7675 35.4352L84.1141 35.7819V84.8352C84.1141 88.3885 81.1675 91.3352 77.6141 91.3352L77.7008 91.4219ZM28.3008 16.0219C26.1341 16.0219 24.4008 17.7552 24.4008 19.9219V84.9219C24.4008 87.0885 26.1341 88.8219 28.3008 88.8219H77.7008C79.8675 88.8219 81.6008 87.0885 81.6008 84.9219V36.9085C77.6141 32.9219 74.4075 29.7152 71.2008 26.5085C67.9941 23.3019 64.7875 20.0085 60.7141 15.9352H28.3008V16.0219Z"
                        fill="#230078" />
                    <path
                        d="M51.7012 36.9086H33.5012C32.8078 36.9086 32.2012 36.3019 32.2012 35.6086C32.2012 34.9153 32.8078 34.3086 33.5012 34.3086H51.7012C52.3945 34.3086 53.0012 34.9153 53.0012 35.6086C53.0012 36.3019 52.3945 36.9086 51.7012 36.9086Z"
                        fill="#230078" />
                    <path
                        d="M72.5012 53.7211H33.5012C32.8078 53.7211 32.2012 53.1144 32.2012 52.4211C32.2012 51.7278 32.8078 51.1211 33.5012 51.1211H72.5012C73.1945 51.1211 73.8012 51.7278 73.8012 52.4211C73.8012 53.1144 73.1945 53.7211 72.5012 53.7211Z"
                        fill="#230078" />
                    <path
                        d="M72.5012 73.2211H33.5012C32.8078 73.2211 32.2012 72.6144 32.2012 71.9211C32.2012 71.2278 32.8078 70.6211 33.5012 70.6211H72.5012C73.1945 70.6211 73.8012 71.2278 73.8012 71.9211C73.8012 72.6144 73.1945 73.2211 72.5012 73.2211Z"
                        fill="#230078" />
                </g>
            </g>
        </g>
        <defs>
            <clipPath id="clip0_851_8931">
                <rect width="106.919" height="104" fill="white" transform="translate(0 0.421875)" />
            </clipPath>
            <clipPath id="clip1_851_8931">
                <rect width="104" height="104" fill="white" transform="translate(1 0.421875)" />
            </clipPath>
            <clipPath id="clip2_851_8931">
                <rect width="104" height="104" fill="white" transform="translate(1 0.421875)" />
            </clipPath>
        </defs>
    </svg>

</template>